import { systemEngineEnvironment } from "services/environment/systemEngine";

import { Privilege, PrivilegeObjectType } from "./types";

// todo: check with Tal if we need to check for owner here
export const getOwnedAccountObjectsPrivileges = async (userName: string) => {
  const sql = `
select user_name as object_name, '${PrivilegeObjectType.user}' AS object_type, 'MODIFY' AS privilege_type from information_schema.users where user_owner='${userName}'
union
select role_name as object_name, '${PrivilegeObjectType.role}' as object_type, 'MODIFY' AS privilege_type from information_schema.enabled_roles where role_owner='${userName}'
union 
select catalog_name as object_name, '${PrivilegeObjectType.database}' as object_type, 'MODIFY' AS privilege_type from information_schema.catalogs where catalog_owner='${userName}'
union
select engine_name as object_name, '${PrivilegeObjectType.engine}' as object_type, 'MODIFY' AS privilege_type from information_schema.engines where engine_owner='${userName}'
`;

  const result = await systemEngineEnvironment.execute<Privilege>(sql);

  const [response] = result;
  return response.rows;
};
